module.exports = __webpack_public_path__ + "static/media/photo10.8b629606.jpg";